import LegArrival from "./arrive";
import LegLoading from "./loading";
import LegDepart from "./depart";
import PODScreen from "./pod";
import PODShipmentScreen from "./shipment";
import Start from "./start";
import CollectScreen from './collect';

const routes = [
  {
    path: "/pod/:id/start",
    component: Start,
  },
  {
    path: "/pod/:id/arrival",
    component: LegArrival,
  },
  {
    path: "/pod/:id/loading",
    component: LegLoading,
  },
  {
    path: "/pod/:id/departure",
    component: LegDepart,
  },
  {
    path: "/collect/:id",
    component: CollectScreen,
  },
  {
    path: "/pod/:id",
    component: PODScreen,
  },
  {
    path: "/pod/:id/shipment",
    component: PODShipmentScreen,
  },
];

export default routes;
